import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { OUT_OF_STOCK } from "../../constants";
import { getProduct } from "../../../../../api/calls/product/get_product";
import { getRelatedProducts } from "../../../../../api/calls/product/related_products";
import { add_product_thunk } from "../../../../../reducers/slices/basket/thunks/add_product_thunk";
export var TABS;
(function (TABS) {
    TABS["information"] = "information";
    TABS["reviews"] = "review";
})(TABS || (TABS = {}));
function isHTML(str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
}
export function useProductState() {
    const { productId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { addingToBasket: { id, isAddingToBasket }, } = useSelector((state) => state.basketState);
    const { selection } = useSelector((state) => state.selectionState);
    const { user } = useSelector((state) => state.userState);
    const [retrievedProduct, setRetrievedProduct] = useState({
        _id: "",
        sku: "",
        title: "",
        sub_title: "",
        description: "",
        price: "0",
        promotion_price: "0",
        on_promotion: false,
        image_url: "",
        status: "",
        image_list: [],
        rating: {
            average: "0",
            count: "0",
        },
        tags: [],
        variations: [],
        stock: [],
    });
    const [currentTab, setCurrentTab] = useState(TABS.information);
    const [isBuyingProduct, setIsBuyingProduct] = useState(false);
    const [isHtmlString, setIsHtmlString] = useState(false);
    const [productDescriptionInHtml, setProductDescriptionInHtml] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [selectedProductVariation, setSelectedProductVariation] = useState();
    const [totalProductPrice, setTotalProductPrice] = useState("0");
    const [isLoading, setIsLoading] = useState(true);
    const [relatedProducts, setRelatedProducts] = useState([]);
    const [relatedProductsLoading, setRelatedProductsLoading] = useState(false);
    const handleTabChanged = useCallback((targetTab) => () => {
        if (currentTab === targetTab) {
            return;
        }
        setCurrentTab(targetTab);
    }, [currentTab]);
    const handleVariantSelected = useCallback((variation) => (v) => {
        setSelectedProductVariation({ ...variation.variations.find((variant) => variant.title == v), type: variation.type });
    }, []);
    const handleAddToCart = useCallback(() => {
        dispatch(add_product_thunk({
            product: retrievedProduct,
            quantity: quantity,
            selectedVariations: selectedProductVariation ? [selectedProductVariation] : null,
        }));
    }, [quantity, retrievedProduct, selectedProductVariation]);
    const handleSave = useCallback(() => {
        // dispatch(
        //   add_product_thunk({
        //     product: retrievedProduct,
        //     quantity: quantity,
        //     selectedVariations: selectedProductVariation ? [selectedProductVariation] : null,
        //   }),
        // );
        // setIsBuyingProduct(true);
    }, [quantity, retrievedProduct, selectedProductVariation]);
    useEffect(() => {
        if (selectedProductVariation) {
            // set the total product price as the default variant price plus the product price
            setTotalProductPrice((parseFloat(selectedProductVariation.price) + parseFloat(retrievedProduct.price)).toFixed(2));
        }
        else {
            // set the total prodct price as the product price
            setTotalProductPrice(retrievedProduct.price);
        }
    }, [selectedProductVariation]);
    useEffect(() => {
        if (selection.selectedProduct?._id ?? productId) {
            getProduct({
                _id: selection?.selectedProduct?._id ?? productId,
            }).then((response) => {
                setIsLoading(false);
                setRetrievedProduct(response.content);
                // determine if product description is html or string
                setIsHtmlString(isHTML(response.content.description));
                // we can define this better as a helper function to set defaults based on color and size
                // set the first variant as the default - for as long as that variant is in stock
                const defaultVariant = response.content?.variations[0]?.variations.filter((v) => v.status != OUT_OF_STOCK).at(0);
                if (defaultVariant) {
                    setSelectedProductVariation({ ...defaultVariant, type: response.content.variations[0].type });
                }
                else {
                    setSelectedProductVariation(null);
                }
            });
            setRelatedProductsLoading(true);
            getRelatedProducts({
                product_id: productId ?? "",
            }).then((response) => {
                setRelatedProductsLoading(false);
                if (response.success) {
                    setRelatedProducts(response.content.product_list ?? []);
                }
                else {
                    setRelatedProductsLoading(false);
                }
            });
        }
        else {
            navigate(-1);
        }
    }, [productId]);
    useEffect(() => {
        // buying means a user is ready to checkout the product
        if (isBuyingProduct && !isAddingToBasket) {
            navigate("/basket");
            setIsBuyingProduct(false);
        }
    }, [isBuyingProduct, isAddingToBasket]);
    useEffect(() => {
        if (isHtmlString) {
            setProductDescriptionInHtml(retrievedProduct.description);
        }
    }, [isHtmlString]);
    return useMemo(() => ({
        currentTab,
        handleAddToCart,
        handleSave,
        handleTabChanged,
        handleVariantSelected,
        isAddingToBasket,
        isHtmlString,
        productDescriptionInHtml,
        retrievedProduct,
        selectedProductVariation,
        totalProductPrice,
        isLoading,
        relatedProducts,
        relatedProductsLoading,
    }), [
        currentTab,
        handleAddToCart,
        handleSave,
        handleTabChanged,
        handleVariantSelected,
        isAddingToBasket,
        isHtmlString,
        productDescriptionInHtml,
        retrievedProduct,
        selectedProductVariation,
        totalProductPrice,
        isLoading,
        relatedProducts,
        relatedProductsLoading,
    ]);
}
